export default class tabManager{
    constructor(param,scroll){

        /* 必要なDOM */
        this.trigger = document.querySelectorAll('.js__tab');
        this.content = document.querySelectorAll('.js__tab__content');
        this.contentTitle = document.querySelectorAll('.l-section__main .title>*');
        this.contentText = document.querySelectorAll('.l-section__main .text>*');
        this.contentIllust = document.querySelectorAll('.l-section__main .illust');
        this.contentList = document.querySelectorAll('.l-section__content');
        this.flowList = document.querySelectorAll('.js__tsc-y-flow');

        this.spTrigger = document.querySelectorAll('.l-section__main .c-btn');

        this.target = 0;

        this.param = param;
        this.scroll = scroll;

        if(window.innerWidth>param.breakpoint){
            TweenMax.set(this.content,{
                display:'none'
            });
            TweenMax.set(this.content[0],{
                display:'block'
            });
            TweenMax.set([this.contentTitle[0],this.contentText[0],this.contentIllust[0],this.contentList[0]],{
                display:'block',
                opacity:1
            });
        }

        this.trigger[0].classList.add("type-active");

        this.w = 0;
        this.h = 0;

        /* ステータス */
        this.status = {
            device : ( window.innerWidth>param.breakpoint )?"pc":"sp",
            animation : false
        }

    }
    init() {

        let _length = this.content.length;
        //pc
        for(var i = 0 ; i < _length ; i++){
            let _index = i;
            this.trigger[i].addEventListener('click', (e) => {
                if(this.status.animation) return;
                this.status.animation = true;
                this.target = _index;
                this.change('pc');
            }, false);
        }
        //sp
        for(var i = 0 ; i < _length ; i++){

            let _index = i;

            this.spTrigger[i].addEventListener('click', (e) => {
                if(this.status.animation) return;
                this.status.animation = true;
                this.target = _index;
                if(!this.contentList[this.target].classList.contains('is-open')){
                    this.change('sp','open');
                }else{
                    this.change('sp','close');
                }
            }, false);

        }

    }

    change(_agent,_type) {

        if(_agent === 'pc'){
            TweenMax.set(this.trigger, {className:"-=type-active"});
            TweenMax.set(this.trigger[this.target], {className:"+=type-active"});
            TweenMax.to(this.flowList, 0.3 , {
                x:-50,
                z:-5,
                y:-5,
                opacity: 0,
            });
            TweenMax.to(this.contentIllust, 0.4 ,{
                z:-25,
                rotation:this.getRandom(-15, 15),
                opacity: 0,
                ease : Sine.easeIn
            });
            TweenMax.to(this.contentList, 0.4 ,{
                y:20,
                opacity: 0,
                ease : Sine.easeIn
            });
            TweenMax.to([this.contentTitle,this.contentText], 0.4 ,{
                rotation:1,
                y:'120%',
                z:-1,
                transformOrigin: "-100% 0%",
                ease : Circ.easeIn,
                onComplete:()=>{
                    TweenMax.set(this.content, {
                        display: 'none',
                        opacity: 0
                    });
                    TweenMax.set(this.content[this.target], {
                        display: 'block',
                        opacity: 1,
                        onComplete:()=>{
                            TweenMax.staggerTo([this.contentTitle[this.target],this.contentText[this.target]], 0.5 , {
                                rotation:0,
                                y:'0%',
                                z:0,
                                opacity:1,
                                transformOrigin: "-100% 0%",
                                ease : Circ.easeOut
                            },0.2);
                            TweenMax.to(this.contentIllust[this.target], 0.7 , {
                                delay:0.2,
                                z:0,
                                rotation:0,
                                opacity: 1,
                                ease : Back.easeOut.config(1)
                            });
                            TweenMax.set(this.contentList[this.target],  {
                                y:0,
                                opacity: 1,
                                onComplete:()=>{
                                    if(Useragnt.pc) {
                                        if (document.querySelector('.js__tsc-flow.is-anime')) {
                                            document.querySelector('.js__tsc-flow.is-anime').classList.remove("is-anime");
                                        }
                                        this.contentList[this.target].classList.add("is-anime");
                                        this.w = window.innerWidth;
                                        this.h = window.innerHeight;
                                        this.scroll.resize(this.w,this.h);
                                        this.status.animation = false;
                                        this.scroll.status.comp = false;
                                    }
                                }
                            });
                            if(Useragnt.tablet) {
                                TweenMax.staggerFromTo(this.contentList[this.target].querySelectorAll('li'), 0.6, {
                                    x: -50,
                                    z: -5,
                                    y: -5,
                                    opacity: 0,
                                }, {
                                    delay:0.7,
                                    x: 0,
                                    z: 0,
                                    y: 0,
                                    opacity: 1,
                                    ease: Back.easeOut.config(1),
                                    onComplete: () => {
                                        this.w = window.innerWidth;
                                        this.h = window.innerHeight;
                                        this.scroll.resize(this.w, this.h);
                                        this.status.animation = false;
                                    }
                                }, 0.15);
                            }
                        }
                    });
                }
            });
        }else{
            if(_type === 'open'){
                this.spTrigger[this.target].classList.add("is-open");
                this.contentList[this.target].classList.add("is-open");
                this.spTrigger[this.target].querySelector('.jp').innerHTML = 'ご契約フローを閉じる';
                TweenMax.set(this.contentList[this.target].querySelectorAll('li'), {
                    x: 0,
                    z: 0,
                    y: 0
                });
                TweenMax.fromTo(this.contentList[this.target],0.3, {
                    y: -35,
                },{
                    y:0,
                    ease : Sine.easeOut,
                });
                TweenMax.to(this.contentList[this.target],0.6, {
                    display: 'block',
                    opacity: 1,
                    ease : Sine.easeOut,
                    onComplete:()=>{
                        this.w = window.innerWidth;
                        this.h = window.innerHeight;
                        this.scroll.resize(this.w,this.h);
                        this.status.animation = false;
                    }
                });
            }else{
                this.spTrigger[this.target].classList.remove("is-open");
                this.contentList[this.target].classList.remove("is-open");
                this.spTrigger[this.target].querySelector('.jp').innerHTML = 'ご契約フローを見る';
                TweenMax.to(this.contentList[this.target],0.3, {
                    display: 'none',
                    opacity: 0,
                    ease : Sine.easeOut,
                    onComplete:()=>{
                        TweenMax.to(this.contentList[this.target].querySelectorAll('li'), 0.3, {
                            opacity: 0,
                            ease: Back.easeOut.config(1),
                        });
                        this.w = window.innerWidth;
                        this.h = window.innerHeight;
                        this.scroll.resize(this.w,this.h);
                        this.status.animation = false;
                    }
                });
                TweenMax.to(this.contentList[this.target],0.6, {
                    y: -90,
                    ease : Sine.easeIn
                });
            }
        }

    }

    set(type){ // pcサイズ、spサイズリサイズによる初期化

        let _length = this.contentList.length;
        for(var i = 0 ; i < _length ; i++){
            this.contentList[i].classList.remove("is-open");
        }

        switch(type) {
            case "pc":
                TweenMax.set(this.content,{
                    display:'none'
                });
                TweenMax.set([this.contentTitle,this.contentText,this.contentIllust,this.contentList],{
                    opacity:0,
                    z:0,
                    y:0,
                    rotation:0
                });
                TweenMax.set([this.content[0],this.contentTitle[0],this.contentText[0],this.contentIllust[0]],{
                    x:0,
                    y:0,
                    rotation:0,
                    display:'block',
                    opacity:1
                });
                TweenMax.set([this.contentList,this.contentList[this.target].querySelectorAll('li')],{
                    display:'block',
                    opacity:1
                });
                TweenMax.set(this.trigger, {className:"-=type-active"});
                TweenMax.set(this.trigger[0], {className:"+=type-active"});
                break;
            case "sp":
                let _length = this.content.length;
                for(var i = 0 ; i < _length ; i++){
                    TweenMax.set([this.contentTitle[i],this.contentText[i],this.contentIllust[i],this.contentList[i]],{
                        opacity:1,
                        x:'0%',
                        y:'0%',
                        z:0,
                        rotation:0
                    });
                    TweenMax.set(this.content[i],{
                        display:'block',
                        opacity:1
                    });
                    TweenMax.set(this.contentList[i],{
                        display:'none',
                        opacity:0
                    });
                    TweenMax.set([this.contentList[i].querySelectorAll('li')],{
                        x:0,
                        y:0,
                        display:'block',
                        opacity:1
                    });
                    this.spTrigger[i].classList.remove("is-open");
                    this.contentList[i].classList.remove("is-open");
                    this.spTrigger[i].querySelector('.jp').innerHTML = 'ご契約フローを見る';
                }
                break;
        }

    }

    resize(_w,_h){
        if(_w>this.param.breakpoint){
            if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
        }
    }

    getRandom(max, min){
        return Math.floor(Math.random() * (1 + max - min) + min);
    }

}